<template>
  <div class="est-room__card est-room__info">
    <!-- Host kabukta üst şerit görmez; süre ve bağlantı bilgisi kartın başında durur.
         Danışan sayfasında aynı bilgi üst şeritte, burada tekrar basılmaz. -->
    <div v-if="showStatus" class="est-room__info-status">
      <span class="est-room__pill" :class="connectionState.tone">
        <span class="est-room__pill-dot" aria-hidden="true"></span>{{ $t(connectionState.label) }}
      </span>
      <span class="est-room__timer" :title="$t('OnlineMeetingComponent.CallDuration')">
        <font-awesome-icon icon="fa-solid fa-clock" /> {{ elapsedLabel }}
      </span>
    </div>

    <meeting-ticket-component v-if="!isHost"
                              :name="counterpartName"
                              :eyebrow="$t('OnlineMeetingComponent.VegaRoomHost')"
                              :info="meetingInfo"
                              :connection="connection" />
    <meeting-details-component v-else-if="meeting.isGuestCustomer" :meeting="meeting" />

    <section class="est-room__section">
      <p class="est-room__label">
        <font-awesome-icon icon="fa-solid fa-paperclip" /> {{ $t('Shared') }}
      </p>
      <meeting-multimedia-component :meeting="meeting" />
    </section>
  </div>
</template>

<script>
  import MeetingDetailsComponent from './MeetingDetailsComponent.vue'
  import MeetingMultimediaComponent from './MeetingMultimediaComponent.vue'
  import MeetingTicketComponent from './MeetingTicketComponent.vue'

  // Görüşme hâlindeki bilgi kartı: durum, karşı taraf (danışanda randevu fişi,
  // hostta danışan özeti) ve paylaşılan dosyalar. Sekme ya da açılır panel değil:
  // bilgi her an görünür, sohbet ayrı kartta altındadır. Bitir düğmesi buradan
  // sahnedeki kontrol şeridine taşındı.
  export default {
    name: 'MeetingRightComponent',
    components: {
      MeetingDetailsComponent,
      MeetingMultimediaComponent,
      MeetingTicketComponent
    },
    props: {
      meeting: {
        type: Object,
        required: true
      },
      meetingInfo: {
        type: Object,
        default: null
      },
      counterpartName: {
        type: String,
        default: ''
      },
      connection: {
        type: Object,
        default: null
      },
      isHost: Boolean,
      showStatus: Boolean,
      connectionState: {
        type: Object,
        required: true
      },
      elapsedLabel: {
        type: String,
        default: ''
      }
    }
  }
</script>
